import { GetPermissions } from '../../../modules/auth';

export const AGENT_STUDIO_PERMISSIONS = {
  access: 'agent-studio-view',
  dashboardView: 'agent-studio-dashboard-view',
  activitiesView: 'agent-studio-activities-view',
  activitiesDecide: 'agent-studio-activities-decide',
  agentsView: 'agent-studio-agents-view',
  agentsManage: 'agent-studio-agents-manage',
  agentsDelete: 'agent-studio-agents-delete',
  agentsChat: 'agent-studio-agents-chat',
  flowsView: 'agent-studio-flows-view',
  flowsManage: 'agent-studio-flows-manage',
  flowsDelete: 'agent-studio-flows-delete',
  flowsExecute: 'agent-studio-flows-execute',
  knowledgeBasesView: 'agent-studio-knowledge-bases-view',
  knowledgeBasesManage: 'agent-studio-knowledge-bases-manage',
  knowledgeBasesDelete: 'agent-studio-knowledge-bases-delete',
  runsView: 'agent-studio-runs-view',
  budgetView: 'agent-studio-budget-view',
  budgetManage: 'agent-studio-budget-manage',
  budgetRequest: 'agent-studio-budget-request',
  costsView: 'agent-studio-costs-view',
  usersManage: 'agent-studio-users-manage',
} as const;

export type AgentStudioPermission = typeof AGENT_STUDIO_PERMISSIONS[keyof typeof AGENT_STUDIO_PERMISSIONS];

export function useAgentStudioPermissions() {
  const permissions = GetPermissions();
  const names = new Set<string>((permissions ?? []).map((feature: { name?: string }) => feature.name ?? ''));

  return {
    isReady: (permissions ?? []).length > 0,
    has: (permission: AgentStudioPermission) => names.has(permission),
    hasAny: (...requested: AgentStudioPermission[]) => requested.some((permission) => names.has(permission)),
  };
}
